// extracted by mini-css-extract-plugin
module.exports = {"guide":"SellSet_guide__cCRSc","intro":"SellSet_intro__2ubUz","title":"SellSet_title__2CZHX","desc":"SellSet_desc__2gNH7","titleAndDesc":"SellSet_titleAndDesc__n2sdM"};